import { createContext } from 'react';

import { SelectedServerContextProps } from './SelectedServerContext.types';

export const SelectedServerContext = createContext<SelectedServerContextProps | undefined>(undefined);
